<template>
  <div id="TransferHierarchy">
    <v-dialog v-model="open" persistent max-width="1200">
      <v-card class="align-center text-center">
        <v-card-text>
          <div class="pt-5 d-flex align-center justify-space-between">
            <h1>Preencha os dados a seguir</h1>

            <v-btn icon @click="close()" class="align-self-end">
              <v-icon> mdi-close </v-icon>
            </v-btn>
          </div>
          <div class="mt30"></div>

          <v-tabs v-model="currentTab">
            <v-tab>Dados Gerais</v-tab>
            <v-tab>Financeiro</v-tab>
          </v-tabs>

          <v-tabs-items v-model="currentTab" class="my-2">
            <v-tab-item class="py-4">
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field
                    ref="freightPrice"
                    v-model="freightPrice"
                    label="Preço do Frete"
                    v-money="money"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    ref="totalMileage"
                    v-model="totalMileage"
                    label="Quilometragem total"
                    v-money="totalMileageMask"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-autocomplete
                    v-model="directDeliverer"
                    :items="directDeliverers"
                    label="Motorista Direto"
                    item-text="name"
                    return-object
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" md="6">
                  <v-select
                    v-model="justification"
                    label="Justificativa"
                    :items="getJustificationsById"
                    item-text="name"
                    item-value="id"
                  ></v-select>
                </v-col>
              </v-row>
            </v-tab-item>
            <v-tab-item class="py-4" eager>
              <v-row>
                <v-col cols="12">
                  <advance-form
                    v-if="open"
                    :forecastPayment.sync="forecastPayment"
                    :advanceAmount.sync="advanceAmount"
                  />
                </v-col>
                <v-col cols="12">
                  <div class="text-left">
                    <h1 class="mt-8 mb-4">Descrição dos Adicionais</h1>
                    <a href="#/financial/aditionals" target="_blank"> Clique aqui para incluir novos adicionais </a>
                    <v-row dense class="my-4">
                      <v-col>
                        <related-aditionals-panel
                          credits-only
                          :applicationUserId="delivererUserId"
                          v-model="relatedAditionals"
                          :aditionalRelated="additionalsDto"
                          @clickAddAditionals="onClickAddRelatedAditional"
                        />
                      </v-col>
                    </v-row>
                  </div>
                </v-col>

                <v-col cols="12">
                  <aditionals-form
                    v-model="additionalsDto"
                    @relatedAditionalRemove="onRelatedAditionalRemove"
                    :restrictedBoardingOrStopIds="restrictedBoardingOrStopIds"
                    :isTranshipmentAditionals="!shipmentTransfer"
                    credits-only
                  >
                  </aditionals-form>
                </v-col>
              </v-row>
            </v-tab-item>
          </v-tabs-items>

          <div class="mt10"></div>
        </v-card-text>
        <v-card-actions class="d-flex justify-space-between pb-5">
          <v-row>
            <v-col class="d-flex">
              <v-btn color="error" class="flex-grow-1" large @click="close(false, null)"> Cancelar </v-btn>
            </v-col>
            <v-col class="d-flex">
              <v-tooltip top :disabled="hasValidFinancialData">
                <template v-slot:activator="{ on, attrs }">
                  <div class="d-flex w-100" v-bind="attrs" v-on="on">
                    <v-btn
                      class="flex-grow-1"
                      color="success"
                      large
                      :loading="loading"
                      :disabled="shouldDisableButton"
                      @click="shipmentTransfer ? sendTransferShipments() : sendTransferStops()"
                    >
                      Confirmar
                    </v-btn>
                  </div>
                </template>
                <span> Previsão de pagamento obrigatória para adiantamento ou adicionais </span>
              </v-tooltip>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { VMoney } from 'v-money';
import removePriceMask from '@/utils/removePriceMask';
import AditionalsForm from '@/components/AditionalsForm.vue';
import AdvanceForm from '@/components/AdvanceForm';
import RelatedAditionalsPanel from '@/components/AccountsPayable/RelatedAditionalsPanel';
export default {
  name: 'TransferHierarchy',
  components: {
    AditionalsForm,
    AdvanceForm,
    RelatedAditionalsPanel
  },
  props: {
    open: {
      default: false,
      type: Boolean
    },
    shipmentTransfer: {
      default: false,
      type: Boolean
    },
    shouldKeepTranshipmentValue: {
      default: false,
      type: Boolean
    },
    newTranshipmentId: {
      default: null,
      type: String
    },
    selectedCheckbox: {
      default: null,
      type: Array
    }
  },
  directives: { money: VMoney },
  data: () => ({
    directDeliverers: [],
    directDeliverer: null,
    relatedAditionals: [],
    currentTab: 0,
    forecastPayment: null,
    advanceAmount: null,
    additionalsDto: [],
    money: {
      decimal: ',',
      thousands: '.',
      prefix: 'R$ ',
      suffix: '',
      precision: 2,
      masked: false /* doesn't work with directive */
    },
    totalMileageMask: {
      decimal: ',',
      thousands: '.',
      prefix: '',
      suffix: '',
      precision: 0,
      masked: false /* doesn't work with directive */
    },
    directDelivererId: null,
    freightPrice: null,
    justification: null,
    totalMileage: null,
    loading: false,

    message: []
  }),
  watch: {
    open: {
      handler(isOpen) {
        this.relatedAditionals = [];
        this.additionalsDto = [];
        this.currentTab = 0;
        if (isOpen) {
          this.forecastPayment = null;
          this.advanceAmount = null;
          this.directDeliverer = null;
          this.freightPrice = null;
          this.justification = null;
          this.totalMileage = null;
          this.additionalsDto = [];
          if (this.$refs.freightPrice) {
            this.$refs.freightPrice.$el.getElementsByTagName('input')[0].value = 0;
            this.$refs.totalMileage.$el.getElementsByTagName('input')[0].value = 0;
          }
          this.fetchAllJustifications();
        }
      }
    },

    delivererUserId: {
      handler() {
        this.additionalsDto = [];
        this.relatedAditionals = [];
      }
    }
  },
  computed: {
    ...mapGetters('CouriersStore', ['getSummaryData']),
    ...mapGetters('NfeStore', ['getJustificationsById']),
    justificationsIdToFetch() {
      return this.shipmentTransfer ? 1 : 3;
    },
    selectedBoardingIds() {
      return this.selectedCheckbox.map((selected) => {
        const { boardingId, id } = selected;
        return boardingId != null ? boardingId : id;
      });
    },
    selectedStopIds() {
      return this.selectedCheckbox.map((selected) => {
        const { stopId, id } = selected;
        return stopId != null ? stopId : id;
      });
    },
    restrictedBoardingOrStopIds() {
      return this.shipmentTransfer ? this.selectedBoardingIds : this.selectedStopIds;
    },
    shouldDisableButton() {
      return !this.hasValidTransferData || !this.hasValidFinancialData;
    },
    hasValidFinancialData() {
      const hasAdvance = this.advanceAmount ? Number(this.transformPriceToSend(this.advanceAmount)) > 0 : false;
      const hasAdditionals = this.additionalsDto.length > 0;
      const hasPaymentForecast = this.forecastPayment !== null;

      if (!hasAdvance && !hasAdditionals && !hasPaymentForecast) return true;
      else if (hasPaymentForecast && hasAdvance && hasAdditionals) return true;
      else if (hasPaymentForecast && hasAdvance) return true;
      else return false;
    },
    hasValidTransferData() {
      return (
        Number(this.transformPriceToSend(this.freightPrice)) !== 0 &&
        this.totalMileage !== '0' &&
        this.justification !== null &&
        this.directDeliverer !== null
      );
    },
    delivererUserId() {
      return this.directDeliverer !== null ? this.directDeliverer.aspNetUserId : null;
    },
    hasRelatedAditionalsAdded() {
      return this.additionalsDto.some((aditional) => aditional.isRelatedAditional);
    }
  },

  created() {
    this.fetchDirectDeliverers();
  },

  methods: {
    ...mapActions('TranshipmentStore', ['setTransferDataStops']),
    ...mapActions('ShipmentStore', ['sendtransferHierarchy']),
    ...mapActions('NfeStore', ['fetchJustificationsById']),
    ...mapActions('AccountsStore', ['getDirectDeliverersForPaymentOrder']),
    async fetchAllJustifications() {
      try {
        await this.fetchJustificationsById(this.justificationsIdToFetch);
      } catch (e) {
        console.error(e);
      }
    },
    async sendTransferStops() {
      const advanceAmount = Number(this.transformPriceToSend(this.advanceAmount));
      this.transformPrice();
      const recalculateValue = this.shouldKeepTranshipmentValue;
      const additionalsIds = this.additionalsDto.map((item) => item.id);
      const body = {
        advanceAmount: advanceAmount ? advanceAmount : null,
        paymentForecast: this.forecastPayment,
        additionals: {
          id: additionalsIds
        },
        transhipmentDestinationId: this.newTranshipmentId,
        directDelivererId: this.directDeliverer.id,
        freightPrice: Number(this.freightPrice),
        totalMileage: Number(this.totalMileage),
        justification: this.justification,
        stopsIds: this.selectedCheckbox
          .filter((item) => {
            if (item.type === 'Parada') {
              return item.id;
            }
          })
          .map((item) => item.id),
        deliveriesIds: this.selectedCheckbox
          .filter((item) => {
            if (item.type === 'Entrega') {
              return item.id;
            }
          })
          .map((item) => item.id)
      };
      this.loading = true;
      try {
        const data = await this.setTransferDataStops({ body, recalculateValue });

        if (data.success) {
          this.message = {
            errors: ['Parabéns! Transferência realizada com sucesso!'],
            errorsType: 'success'
          };
        } else {
          this.message = {
            errors: data.errors,
            errorsType: 'error'
          };
        }
      } catch (e) {
        console.error(e);
        this.message = {
          errors: ['Opss, algo deu errado!'],
          errorsType: 'error'
        };
      } finally {
        this.close(true, this.message);
        this.loading = false;
      }
    },
    async sendTransferShipments() {
      this.transformPrice();
      const advanceAmount = Number(this.transformPriceToSend(this.advanceAmount));
      const additionalsIds = this.additionalsDto.map((item) => item.id);
      const body = {
        advanceAmount: advanceAmount ? advanceAmount : null,
        paymentForecast: this.forecastPayment,
        additionals: {
          id: additionalsIds
        },
        directDelivererId: this.directDeliverer.id,
        freightPrice: Number(this.freightPrice),
        totalMileage: Number(this.totalMileage),
        justification: this.justification,
        nfeIds: this.selectedCheckbox
          .filter((item) => {
            if (item.type === 'Nota Fiscal') {
              return item.id;
            }
          })
          .map((item) => item.id),
        stopIds: this.selectedCheckbox
          .filter((item) => {
            if (item.type === 'Parada') {
              return item.id;
            }
          })
          .map((item) => item.id),
        deliveryIds: this.selectedCheckbox
          .filter((item) => {
            if (item.type === 'Entrega') {
              return item.id;
            }
          })
          .map((item) => item.id),
        cargoIds: this.selectedCheckbox
          .filter((item) => {
            if (item.type === 'Carga') {
              return item.id;
            }
          })
          .map((item) => item.id),
        boardingIds: this.selectedCheckbox
          .filter((item) => {
            if (item.type === 'Embarque') {
              return item.id;
            }
          })
          .map((item) => item.id)
      };

      this.loading = true;

      try {
        const data = await this.sendtransferHierarchy(body);

        if (data.success) {
          this.message = {
            errors: ['Parabéns! Transferência realizada com sucesso!'],
            errorsType: 'success'
          };
        } else {
          this.message = {
            errors: data.errors,
            errorsType: 'error'
          };
        }
      } catch (e) {
        console.error(e);
        this.message = {
          errors: ['Opss, algo deu errado'],
          errorsType: 'error'
        };
      } finally {
        this.close(true, this.message);
        this.loading = false;
      }
    },

    async fetchDirectDeliverers() {
      try {
        this.directDeliverers = await this.getDirectDeliverersForPaymentOrder();
      } catch (error) {
        console.error(error);
      }
    },

    onClickAddRelatedAditional(relatedAditionals) {
      this.additionalsDto = [...this.additionalsDto, ...relatedAditionals];
    },

    onRelatedAditionalRemove(relatedAditional) {
      this.relatedAditionals = [...this.relatedAditionals, relatedAditional];
    },

    transformPriceToSend(element) {
      if (element === null) return null;
      var money = element.toString().trim();
      money = money.replace('R$ ', '').replaceAll('.', '').replace(',', '.');
      return money;
    },
    close(hasChange, message) {
      this.resetFields();
      this.transferStops = false;
      this.thisTranshipmentId = null;
      this.$emit('closeTranshipmentTransfer', hasChange, message);
    },
    resetFields() {
      this.freightPrice = null;
      this.justification = null;
      this.totalMileage = null;
      this.directDeliverer = null;
    },
    transformPrice() {
      this.freightPrice = removePriceMask(this.freightPrice);
      this.totalMileage = removePriceMask(this.totalMileage);
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep.v-input__slot {
  margin: 0;
  padding: 0;

  &::after,
  &::before {
    display: none !important;
  }
}
::v-deep.v-input {
  .v-text-field {
    &__details {
      padding-top: 4px;
      display: inline-block;
    }
  }
}
</style>
